import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { from, race, throwError, timer } from 'rxjs';
import { filter, first, switchMap } from 'rxjs/operators';

import { RequestService } from '@atmi/core/services/request.service';
import { UndoService } from '@atmi/core/services/undo.service';

@Injectable()
export class UndoInterceptorService implements HttpInterceptor {

  constructor(
    private readonly undoService: UndoService,
    private readonly requestService: RequestService,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.method === 'GET') {
      return next.handle(req);
    }

    // TODO: Iterate on array of exclude routes configureted from outside
    if (req.url.includes('/sessions')) {
      return next.handle(req);
    }

    return from(
      race(
        timer(4000),
        this.undoService.selectIsUndoState().pipe(filter((isUndo) => isUndo)),
      )
    ).pipe(
      first(),
      switchMap((winner) => {
        this.requestService.clearState();

        if (typeof winner === 'boolean') {
          return throwError('Cancel an undo request');
        }
        return next.handle(req);
      }),
    );
  }
}
